import dateFormat from 'dateformat';

import banks from '../../../shared/banks.json';
import paymentTypes from '../../../shared/payment-types.json';
import { commaNumber } from '../../NumberField';
import { getSummary } from '../New/Components/utils';
import { FormVariables, Payment } from '../slice/newFormReducers';
import { BorderedStack, Item } from './utils';

type Props = { formVariables: FormVariables };

export default ({ formVariables }: Props) => {
  const summary = getSummary(formVariables);
  const { payments } = formVariables;

  let paymentsArr: Payment[];

  if (!payments || summary.totalPaidAmount <= 0) {
    paymentsArr = [];
  } else {
    paymentsArr = Object.keys(payments)
      .map((uuid) => payments[uuid])
      .filter((payment) => payment.amount)
      .filter((payment) => payment.isPaid);
  }

  return (
    <div className="form-styles">
      <BorderedStack style={{ margin: "-1px" }}>
        {cols.map((col) => (
          <Item
            key={col.key + "title"}
            grow={col.grow}
            style={{
              width: col.width,
              padding: "0 4px",
            }}
          >
            <b>{col.title}</b>
          </Item>
        ))}
      </BorderedStack>

      {paymentsArr.map((payment: Payment) => {
        return (
          <BorderedStack
            key={payment.uuid}
            style={{ margin: "-1px" }}
            horizontal
          >
            {cols.map((col) => (
              <Item
                key={col.key}
                grow={col.grow}
                style={{
                  width: col.width,
                  padding: "0 4px",
                  textAlign: col.textAlign as any,
                }}
              >
                {col.transform(payment) || " "}
              </Item>
            ))}
          </BorderedStack>
        );
      })}

      <BorderedStack style={{ margin: "-1px" }}>
        <Item
          grow
          width="15%"
          style={{
            padding: "0 4px",
            textAlign: "right",
          }}
        >
          <b>Kalan Bakiye:</b> {commaNumber(summary.unpaidTotal)} TL
        </Item>
      </BorderedStack>
    </div>
  );
};

const cols = [
  {
    key: "type",
    title: "Ödeme Yöntemi",
    width: "30%",
    transform: (payment: Payment) =>
      paymentTypes.find((pt) => pt.type === payment.type)?.name,
  },
  {
    key: "description",
    title: "Açıklama",
    width: "40%",
    transform: ({ paidAt, bankId, installments }: Payment) =>
      [
        paidAt && dateFormat(new Date(paidAt), "dd/mm/yyyy"),
        banks.find((b) => b.id === bankId)?.name,
        installments
          ? installments?.includes("Tek")
            ? installments
            : `${installments} Taksit`
          : undefined,
      ]
        .filter((x) => x)
        .join(" - "),
  },
  {
    key: "amount",
    title: "Miktar",
    width: "15%",
    grow: true,
    textAlign: "right",
    transform: ({ amount }: Payment) =>
      amount ? commaNumber(amount) + " TL" : "-",
  },
];
